import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import portfolioImage from "../../assets/portfolio-image.jpg";


export function About() {
  return (
    <Container id="aboutme">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>O'zim haqimda qisqacha</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={100}>
          <p>Shodmonhojaev Azizxon Abror o'g'li, 2001-yil Toshkent shahrida tug'ilgaman. 2016-yil Mirobod tumanidagi 154-maktabni tugatib Mirobod sanoat kasb-hunar kollejida o'qigaman. SMM sohasida 1 yildan beri ishlab kelyapman, shu kungacha 10dan ortiq proektlarni muvaffaqqiyatli tugatdim.</p>
        </ScrollAnimation>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={100}>
          <img style={{width:"70%"}} src={portfolioImage} alt="My image" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
